import { Injectable, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { BaseEndpoint } from '../../app.constants';
import { Observable } from 'rxjs/Observable';
import { LocalCacheService } from '../../core/local-cache/local-cache.service';

@Injectable()
export class SharedCallsService {
    headers: Headers;
    loggedInUserId: string;

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiEndpoint,
        private storage: LocalCacheService) {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');
    }

    public getUserRole(loggedInUser: string) {
        return this.http.get(this.baseApiEndpoint + '/getuserrole/' + loggedInUser).map(response => {
            return response.json();
        }).catch(err => {
            return Observable.of(err);
        });
    }

    public caseLock(caseId, userId) {
        const params = {
            'caseId': caseId,
            'userId': userId
        };
        return this.http.post(this.baseApiEndpoint + '/caselock', params).map(response => {
            return response.json();
        }).catch(err => {
            return Observable.of(err);
        });
    }

    public updateLock(lockId) {
        const lock = JSON.stringify(lockId);
        return this.http.put(this.baseApiEndpoint + '/caselock/' + lockId, lock).map(
            response => {
                return response.json();
            }).catch(err => {
                return Observable.of(err);
            });
    }

    public deleteLock(lockId) {
        return this.http.delete(this.baseApiEndpoint + '/caselock/' + lockId).map(response => {
            return response.json()['result'];
        }).catch(err => {
            return Observable.of(err);
        });
    }

    public getUsers(searchTerm: string) {
        return this.http.get(this.baseApiEndpoint + '/users?searchValue=' + searchTerm).map(response => {
            return response.json()['result'];
        }).catch(err => {
            return Observable.of(err);
        });
    }

    public getCaseLockStatus(caseId) {
        this.loggedInUserId = this.storage.fetchData('userId');
        return this.http.get(this.baseApiEndpoint + '/islocked/' + caseId + '/' + this.loggedInUserId).map
            (response => {
                return response.json();
            }).catch(
                err => {
                    return Observable.of(err);
                });
    }

    public getCaseProgressStatus(caseId) {
        return this.http.get(this.baseApiEndpoint + '/processstatus/' + caseId).map
            (response => {
                return response.json();
            }).catch(
                err => {
                    return Observable.of(err);
                });
    }
    public postCaseProgressStatusData(progressStatusDetails) {
        return this.http.post(this.baseApiEndpoint + '/processstatus', progressStatusDetails).map(
            response => {
                return response.json()['result'];
            }).catch(err => {
                return Observable.of(err);
            });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/services/shared-calls.service.ts